module.exports = __webpack_public_path__ + "static/media/04.c3ab4a4d.png";